import { useEffect } from 'react';

const useFooterVisibility = ({ footerClass = 'hide-hub-spot-icon', targetSelector }) => {
  useEffect(() => {
    const applyHiddenStyles = (element) => {
      element.style.setProperty('opacity', '0', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
      element.style.setProperty('user-select', 'none', 'important');
    };

    const removeHiddenStyles = (element) => {
      element.style.setProperty('opacity', '1', 'important');
      element.style.setProperty('pointer-events', 'all', 'important');
      element.style.setProperty('user-select', 'auto', 'important');
    };

    const toggleStyles = () => {
      const footerExists = document.querySelector(`.${footerClass}`);
      const targetElement = document.querySelector(targetSelector);

      if (targetElement) {
        if (footerExists) {
          applyHiddenStyles(targetElement);
        } else {
          removeHiddenStyles(targetElement);
        }
      }
    };

    const observer = new MutationObserver(toggleStyles);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Initial check
    toggleStyles();

    return () => observer.disconnect();
  }, [footerClass, targetSelector]);
};

export default useFooterVisibility;
